import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const AlignButtons = styled.div`
  display: flex;
  gap: 8px;
`;
